// Adam's view of a client's space (ClientSpace.dc.html's "Adam, as admin" Tweak), for an owner or
// admin at 2-step login: the black bar across the top, and, for an owner, ending the space (no
// board draws it: BUILD-PLAN stage 4 and the test plan's AD-03; client-space ends it, audited as
// client_space_ended with the owner as actor). "Back to People" goes to admin's People list, where
// the client's own page links back to the space.
import { useState } from 'react'
import { Link } from '../../lib/router.jsx'
import { adminPath } from '../../admin/shell/routes.js'
import * as f from '../../lib/format.js'
import { HubFunctionError } from '../../lib/functions.js'
import { COPY } from './copy.js'
import { endSpace } from './data.js'

export function AdamBar({ ctx }) {
  const { first, space } = ctx
  return (
    <div className="ms-bar">
      <span className="ms-bar-text">
        <span className="ms-bar-dot" aria-hidden="true" />
        {space.ended_at ? COPY.barEnded(first, f.shortDate(space.ended_at)) : COPY.bar(first)}
      </span>
      <Link to={adminPath.people()} className="ms-bar-link">{COPY.backToPeople}</Link>
    </div>
  )
}

export function EndSpace({ ctx }) {
  const { space, client, first, reload } = ctx
  const [step, setStep] = useState('idle') // idle | confirm | busy
  const [msg, setMsg] = useState(null)

  async function end() {
    setStep('busy')
    setMsg(null)
    try {
      const answer = await endSpace(space.id)
      setMsg({ bad: false, text: answer?.message || '' })
      setStep('idle')
      reload()
    } catch (err) {
      setMsg({ bad: true, text: err instanceof HubFunctionError ? err.message : COPY.notSaved })
      setStep('confirm')
    }
  }

  if (space.ended_at) return msg ? <p className="ms-end-msg" role="status">{msg.text}</p> : null
  return (
    <section className="ms-end" data-part="end" aria-labelledby="ms-end-h">
      <h2 className="ms-end-h" id="ms-end-h">{COPY.endBox}</h2>
      <p className="ms-end-line">{COPY.endLine(first)}</p>
      {step === 'idle' && <button type="button" className="ms-btn-line ms-btn-line--small" onClick={() => setStep('confirm')}>{COPY.endButton}</button>}
      {step !== 'idle' && (
        <div className="ms-end-confirm">
          <span className="ms-end-ask">{COPY.endConfirm(client?.full_name || first)}</span>
          <span className="ms-end-buttons">
            <button type="button" className="ms-btn ms-btn--small" onClick={end} disabled={step === 'busy'}>{COPY.endYes}</button>
            <button type="button" className="ms-btn-line ms-btn-line--small" onClick={() => { setStep('idle'); setMsg(null) }} disabled={step === 'busy'}>{COPY.endNo}</button>
          </span>
        </div>
      )}
      {msg && <p className={msg.bad ? 'ms-end-msg ms-end-msg--bad' : 'ms-end-msg'} role={msg.bad ? 'alert' : 'status'}>{msg.text}</p>}
    </section>
  )
}
